import { makeStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';

// Original dimensions for percentage calculations
const IMAGE_WIDTH = 936;
const IMAGE_HEIGHT = 1177;
const BORDER_RADIUS = 31;
const BUTTON_SIZE = 61;
const ICON_SIZE = 33;

// Convert to percentages
const toWidthPercent = (value) => `${(value / IMAGE_WIDTH) * 100}%`;
const toHeightPercent = (value) => `${(value / IMAGE_HEIGHT) * 100}%`;

const useStyles = makeStyles(() => ({
  dialogContent: {
    position: 'relative',
    width: '90vw',
    maxWidth: IMAGE_WIDTH,
    // Allow scrolling only when content exceeds viewport height
    maxHeight: '90vh',
    overflow: 'auto',
  },
  dialogImage: {
    width: '100%',
    height: 'auto',
    borderRadius: toWidthPercent(BORDER_RADIUS),
    display: 'block',
  },
  dialogCloseButton: {
    position: 'absolute',
    // Position button center at border-radius center
    // top = (borderRadius - buttonSize/2) as percentage of height
    top: toHeightPercent(BORDER_RADIUS - BUTTON_SIZE / 2),
    right: toWidthPercent(BORDER_RADIUS - BUTTON_SIZE / 2),
    width: toWidthPercent(BUTTON_SIZE),
    // Use aspect-ratio to keep button circular
    aspectRatio: '1 / 1',
    borderRadius: '50%',
    backgroundColor: '#fefefe',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  closeIcon: {
    // 33/61 ≈ 54.1% of button size
    width: `${(ICON_SIZE / BUTTON_SIZE) * 100}%`,
    aspectRatio: '1 / 1',
    position: 'relative',
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '100%',
      // 4/33 ≈ 12% of icon size
      height: '12%',
      backgroundColor: '#f58a1f',
      borderRadius: '10%',
    },
    '&::before': {
      transform: 'translate(-50%, -50%) rotate(45deg)',
    },
    '&::after': {
      transform: 'translate(-50%, -50%) rotate(-45deg)',
    },
  },
}));

function ImageDialog({ open, imageSrc, onClose }) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
        },
      }}
    >
      {imageSrc && (
        <div className={classes.dialogContent}>
          <img
            src={imageSrc}
            alt="Department info"
            className={classes.dialogImage}
          />
          <button
            className={classes.dialogCloseButton}
            onClick={onClose}
            aria-label="Close dialog"
          >
            <span className={classes.closeIcon} />
          </button>
        </div>
      )}
    </Dialog>
  );
}

export default ImageDialog;
